import { InjectionToken } from '@angular/core';

const SERVER_SIDE = new InjectionToken('ServerSide');

/*
 * Public API Surface of ng-server-side
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SERVER_SIDE };
